import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Loader from "../components/Loader";
import { getIdToken, retrieveToken } from "../utility/auth";
import { checkQueryParams } from "../utility/other";
import AccessDenied from "../pages/AccessDenied";
import { fetchCurrentUser, setUserLoggedIn } from "../redux/userSlice";
import { toast } from "react-toastify";

function PrivateRoute({ deny, children }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [canAccess, setAccess] = useState(false);
  const [verifying, setVerifying] = useState(false);

  const hasQueryParams = checkQueryParams(window.location.href, "?");

  useEffect(() => {
    if (hasQueryParams) {
      setVerifying(true);
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      console.error("code",code);
      alert(code)
      retrieveToken(code)
        .then((res) => {
          console.error("code res",res)
          setVerifying(false);
          if (res) {
            setAccess(true);
            dispatch(fetchCurrentUser());
            dispatch(setUserLoggedIn(true));
          }
        })
        .catch((err) => {
          setVerifying(false);
          if (err.errorMessage) {
            toast.error(err.errorMessage);
          }
        });
    } else if (getIdToken()) {
      setAccess(true);
    } else {
     // navigate("/login");
    }
  }, [dispatch, navigate, hasQueryParams]);

  // return children;
  return deny ? (
    <AccessDenied />
  ) : verifying ? (
    <Loader />
  ) : canAccess ? (
    children
  ) : (
    <></>
  );
}

export default PrivateRoute;
